import { CatalogPage } from '~/components/CatalogPage/CatalogPage'

export default function CatalogRoutePage() {
  return <CatalogPage />
}